module.exports = __webpack_public_path__ + "682289a8f043d64c5690f51c1f9058f3.pdf";